import { uploadPdfFileApi } from './pdfConvert';

export const uploadPdfFile = async (uploadParams, formData) => {
  const { status, content } = await uploadPdfFileApi(uploadParams, formData);
  if (status !== 'success') throw new Error({
    errorMessage: 'upLoadFile Fail'
  });
  return content;
};
